import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file TabsITem.ts
 * @author markJia(markjia@tencent.com)
 */
import { Emitter } from '@tencent/glue-util-emitter';
import { guid } from '@tencent/glue-util-helper';
export var TabItem = /*#__PURE__*/function (_Emitter) {
  _inherits(TabItem, _Emitter);

  var _super = _createSuper(TabItem);

  function TabItem(_ref) {
    var _this;

    var id = _ref.id,
        title = _ref.title,
        parent = _ref.parent;

    _classCallCheck(this, TabItem);

    _this = _super.call(this);
    _this.disabled = false;
    _this.insId = guid();
    _this.id = id;
    _this.title = title;
    _this.parent = parent;

    _this.parent.getItemIndex();

    _this.parent.registerTabItem(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(TabItem, [{
    key: "dispose",
    value: function dispose() {
      this.parent.unRegisterTabItem(this);
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getInsId",
    value: function getInsId() {
      return this.insId;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.title;
    }
  }, {
    key: "getData",
    value: function getData() {
      return {
        disabled: this.disabled || this.parent.disabled,
        active: this.parent.isActive(this.id)
      };
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(_ref2) {
      var id = _ref2.id,
          disabled = _ref2.disabled,
          title = _ref2.title;
      this.disabled = disabled;
      this.title = title;
      this.id = id;
    }
  }, {
    key: "onActiveChange",
    value: function onActiveChange(id) {
      if (this.disabled || this.parent.disabled) {
        return;
      }

      this.parent.updateActiveId(id);
    }
  }, {
    key: "refreshItem",
    value: function refreshItem() {
      this.emit('item-change');
    }
  }]);

  return TabItem;
}(Emitter);